import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { RouterLink, RouterOutlet } from '@angular/router'
import { ToastModule } from 'primeng/toast'
import { TPipe } from '@tocdk/lingui-angular'
import { LocalePersistenceService } from './core/i18n/locale-persistence.service'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, ToastModule, TPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly localePersistence = inject(LocalePersistenceService)
}
